import { render, staticRenderFns } from "./SaluteSempliceLoginPage.vue?vue&type=template&id=795dd698&scoped=true"
import script from "./SaluteSempliceLoginPage.vue?vue&type=script&lang=js"
export * from "./SaluteSempliceLoginPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795dd698",
  null
  
)

export default component.exports